import React, { useEffect, useRef, useState } from 'react';
import { InfoOutline } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { Tooltip, TooltipPlacement } from '@yme/atoms/tooltip';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { PRICE_GAP } from './constants';
import { DiscountTextStyled, TextStyled } from './styled';
export function CardProductPriceBlock(props) {
    const { price, discount, isRightToLeft, isLabelFromVisible, extraInformationTooltipText: tooltipText, isBigDesktopFont = true, } = props;
    const { t } = useTranslation();
    const { isMobileView } = useWindowSize();
    const [isPriceWrapped, setIsPriceWrapped] = useState(false);
    const ref = useRef(null);
    const refPrice = useRef(null);
    const refDiscount = useRef(null);
    const labelFrom = t('common_from_label');
    const hasDiscount = Boolean(discount);
    useEffect(() => {
        if (refPrice.current && refDiscount.current && ref.current) {
            setIsPriceWrapped(refPrice.current.clientWidth + refDiscount.current.clientWidth + PRICE_GAP >
                ref.current.clientWidth);
        }
    }, [
        ref?.current?.clientWidth,
        refPrice?.current?.clientWidth,
        refDiscount?.current?.clientWidth,
    ]);
    if (!price) {
        return null;
    }
    const ExtraTooltip = () => {
        return tooltipText ? (React.createElement(FlexWrapper, { ml: INDENT.xxxxs },
            React.createElement(Tooltip, { title: tooltipText, hasEnableClickListener: isMobileView, hasEnableHoverListener: !isMobileView, placement: isMobileView ? TooltipPlacement.RIGHT : TooltipPlacement.ABOVE_CENTER },
                React.createElement(SVGIcon, { type: InfoOutline, 
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }, size: isMobileView ? ICON_SIZE.xs : ICON_SIZE.s, pathFill: colorCoreBlack900Base })))) : null;
    };
    if (isLabelFromVisible && labelFrom) {
        return (React.createElement(FlexWrapper, { isRightToLeft: isRightToLeft, pt: INDENT.xxxxs, gap: hasDiscount && !isLabelFromVisible ? INDENT.sm : INDENT.xxxs },
            labelFrom && (React.createElement(TextStyled, { as: "p", color: colorCoreBlack300, isBigDesktopFont: isBigDesktopFont }, labelFrom)),
            React.createElement(DiscountTextStyled, { isRightToLeft: isRightToLeft, isFromLabelShortForm: isLabelFromVisible },
                React.createElement(TextStyled, { as: "p", color: colorCoreBlack300, isBigDesktopFont: isBigDesktopFont }, discount || price)),
            React.createElement(ExtraTooltip, null)));
    }
    return (React.createElement(FlexWrapper, { isRightToLeft: isRightToLeft, pt: INDENT.xxxxs, gap: hasDiscount && !isPriceWrapped ? INDENT.sm : '', ref: ref, flexDirection: isPriceWrapped ? 'column' : 'row' },
        React.createElement(FlexWrapper, { gap: INDENT.xxxs },
            React.createElement(TextStyled, { as: "p", ref: refPrice, isLineThrough: hasDiscount, color: colorCoreBlack300, isBigDesktopFont: isBigDesktopFont }, price)),
        hasDiscount && (React.createElement(DiscountTextStyled, { isPriceWrapped: isPriceWrapped, isRightToLeft: isRightToLeft },
            React.createElement(FlexWrapper, null,
                React.createElement(TextStyled, { as: "p", ref: refDiscount, color: colorCoreBlack900Base, isBigDesktopFont: isBigDesktopFont }, discount)))),
        React.createElement(ExtraTooltip, null)));
}
CardProductPriceBlock.displayName = 'CardProductPriceBlock_Molecule';
